/**
 * <Figure label="Fig. 1" caption="A description">
 *   <svg viewBox="0 0 820 240">...</svg>
 * </Figure>
 */
export function Figure({ label, caption, children }) {
  return (
    <figure className="my-7 p-5 pb-3 bg-paper-warm border border-rule break-inside-avoid">
      <div className="[&>svg]:block [&>svg]:w-full [&>svg]:h-auto [&>svg]:max-w-full [&>svg]:font-mono">
        {children}
      </div>
      {(label || caption) && (
        <figcaption className="mt-2 font-body italic text-[0.95rem] text-ink-muted text-center leading-snug">
          {label && (
            <span className="inline-block font-mono not-italic text-[10px] uppercase tracking-[0.2em] text-accent mr-1.5">
              {label}
            </span>
          )}
          {caption}
        </figcaption>
      )}
    </figure>
  );
}
